import React from "react";

const Undefined = () => {
  return <div>Undefined</div>;
};

export default Undefined;
